import Injection = EECore.Injection;
import { WidgetResources } from "../../resources/widget";
import Model from "../models/promotion/promotionModel";
import PromotionService from "../../services/promotion/promotionService";
import PersonnalInformation from "../../services/entities/promotion/personnalInformation";
import PhoneNumber from "../../services/entities/promotion/phoneNumber";
import EmailAddress from "../../services/entities/promotion/emailAddress";

@Injection.injectableClass("ProfileReview")
export default class ProfileReview implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("ProfileReview", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("ProfileReview", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("ProfileReview", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  @Injection.injectableProperty("ProfileReview", "PromotionService")
  private promotionService: PromotionService;

  @Injection.injectableProperty("ProfileReview", EECore.Registrations.TEALIUM)
  private tealium: EECore.Tealium;

  constructor(templateFactory: EECore.UI.TemplateFactory, resources: WidgetResources, htmlHelper: EECore.HtmlHelper, promotionService: PromotionService, tealium: EECore.Tealium) {
    this.templateFactory = templateFactory;
    this.resources = resources;
    this.htmlHelper = htmlHelper;
    this.promotionService = promotionService;
    this.tealium = tealium;
  }

  load() {

    const contentRequest = this.promotionService.getProfileReviewContent();
    const personalInformationRequest = this.promotionService.getPersonnalInformation();

    return new EECore.Promise<Element, string>((resolve, reject) => {
      EECore.Promise.all(contentRequest, personalInformationRequest).then((result) => {
        const promotionElement = this.render(result[0], result[1]);
        resolve(promotionElement);
        this.bindEvents(promotionElement);
        this.scheduleDisplay(promotionElement);
      }).catch(() => {
        reject("Could not get the promotion information");
      });
    });
  }

  private render(content: string, personnalInformation: PersonnalInformation): Element {
    const model: Model = { content: content };
    const template = this.templateFactory.getTemplate("ProfileReview", model);
    this.customizeContent(template, personnalInformation);

    return template;
  }

  private customizeContent(content: Element, personnalInformation: PersonnalInformation) {
    let address = "";
    personnalInformation.addressLines.forEach((addressLine: string) => {
      address += `${addressLine}<br />`;
    });

    let emailAddresses = "";
    const showEmailLabel = personnalInformation.emails.length > 1;
    personnalInformation.emails.forEach((email: EmailAddress) => {
      emailAddresses += `<span>${this.formatEmailForDisplay(email, showEmailLabel)}</span>`;
    });

    let phoneNumbers = "";
    const showPhoneNumbersLabel = personnalInformation.phoneNumbers.length > 1;
    personnalInformation.phoneNumbers.forEach((phoneNumber: PhoneNumber) => {
      phoneNumbers += `<span>${this.formatPhoneNumberForDisplay(phoneNumber, showPhoneNumbersLabel)}</span>`;
    });

    content.querySelector("[data-content=address]").innerHTML = address;
    content.querySelector("[data-content=emailAddresses]").innerHTML = emailAddresses;
    content.querySelector("[data-content=phoneNumbers]").innerHTML = phoneNumbers;
    content.querySelector("[data-content=correspondenceLanguage]").textContent = this.formatCorrespondenceLanguage(personnalInformation.correspondenceLanguage);

    if (!emailAddresses) {
      (content.querySelector("[data-content=emailAddresses]") as HTMLElement).style.display = "none";
      (content.querySelector("[data-content=noEmailAddressMessage]") as HTMLElement).style.display = "block";
    }

    if (!phoneNumbers) {
      (content.querySelector("[data-content=phoneNumbers]") as HTMLElement).style.display = "none";
    }
  }

  private formatEmailForDisplay(email: EmailAddress, showLabel: boolean): string {
    let label = "";
    let formattedEmail = `<span>${email.email}</span>`;

    if (showLabel !== false) {
      if (email.type === "HOME") {
        label = this.resources.promotion.emailHome;
      } else if (email.type === "WORK") {
        label = this.resources.promotion.emailWork;
      }
      formattedEmail = `<span>${label}:</span>${formattedEmail}`;
    }

    return formattedEmail;
  }

  private formatPhoneNumberForDisplay(phoneNumber: PhoneNumber, showLabel: boolean): string {
    let label = "";
    let formattedPhoneNumber = `<span>${phoneNumber.phoneNumber}`;
    if (phoneNumber.extension) formattedPhoneNumber += ` #${phoneNumber.extension}`;
    formattedPhoneNumber += "</span>";

    if (showLabel !== false) {
      if (phoneNumber.type === "HOME") {
        label = this.resources.promotion.phoneNumberHome;
      } else if (phoneNumber.type === "WORK") {
        label = this.resources.promotion.phoneNumberWork;
      } else if (phoneNumber.type === "CELL") {
        label = this.resources.promotion.phoneNumberCell;
      } else if (phoneNumber.type === "FAX") {
        label = this.resources.promotion.phoneNumberFax;
      }

      formattedPhoneNumber = `<span>${label}:</span>${formattedPhoneNumber}`;
    }

    return formattedPhoneNumber;
  }

  private formatCorrespondenceLanguage(twoLetterLanguageCode: string): string {
    return twoLetterLanguageCode === "fr" ? this.resources.promotion.correspondenceLanguageFrench : this.resources.promotion.correspondenceLanguageEnglish;
  }

  private bindEvents(content: Element) {
    const dismissButton = content.querySelector(".popup-dismiss");
    dismissButton.addEventListener("click", () => {
      this.promotionService.updateReminder("PROFILE_REVIEW").then(() => {
        this.htmlHelper.removeCssClass(content, "active");
      });
    });
  }

  private scheduleDisplay(content: Element) {
    (content.querySelector(".we_overlayBannerContent") as HTMLElement).style.display = "block";
    setTimeout(() => {
      this.htmlHelper.addCssClass(content, "active");
      this.tealium.trackLink("ProfilLaunch", "Profil_Banner", "ProfilBanner");
    }, 500);
  }
}